import React from 'react';
import classnames from 'classnames';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import s from './WidgetHeader.scss';
const WidgetHeader = ({ header, count, className, extras })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, header && /*#__PURE__*/ React.createElement(Heading, {
        className: s['header']
    }, header, !!count && ' ', !!count && /*#__PURE__*/ React.createElement("span", {
        className: s['count']
    }, shortenNumber(count))), extras);
WidgetHeader.displayName = 'WidgetHeader';
export default WidgetHeader;

//# sourceMappingURL=WidgetHeader.js.map